import {DoorListController} from './door-list.controller';
import template from './door-list.template.html';

export const DoorListComponent = {
    controller: DoorListController,
    templateUrl: template
};



// WEBPACK FOOTER //
// ./src/js/components/door-list/door-list.component.js